<template>
  <v-tooltip bottom :disabled="!$store.state.qlik.contextualHelp || !objectDescription" max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="pa-3">
        <QlikObject v-bind="$props"/>
      </div>
    </template>
    {{ objectDescription }}
  </v-tooltip>
</template>

<script>
import { QlikObject } from '@portal/qlik'

export default {
  name: 'QlikBox',
  components: { QlikObject },
  props: {
    integrator: Object,
    objectId: { type: String, required: true },
    height: { type: String, required: false, default: '100px' },
    noSelections: { type: Boolean, required: false },
    noInteraction: { type: Boolean, required: false }
  },
  data: () => ({
    objectDescription: null
  }),
  watch: {
    'objectId' () {
      this.loadObjectDescription()
    }
  },
  methods: {
    async loadObjectDescription() {
      this.objectDescription = (await this.integrator.getObjectDetails(this.objectId))?.qMetaDef.description
    },
  },
  created() {
    this.loadObjectDescription()
  }
};
</script>